import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchResource, saveResource, removeResource, removeAllResources } from 'ACTIONS/resources.actions';
import { deepEqual } from 'HELPERS/utils';
import { Table, Button, Badge, Popconfirm } from 'antd';
import './DataGrid.less';
import ExportCSV from '../ExportCSV/ExportCSV';

class DataGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
    };
  }
  componentDidMount() {
    const query = {
      type_id: this.props.resourceTypeId,
    };
    this.props.fetchResource(this.props.resource, query);
  }

  componentWillReceiveProps(nextProps) {
    const normalizeParams = params => Object.keys(params)
      .filter(key => !['sort'].includes(key))
      .reduce((obj, key) => {
        // eslint-disable-next-line
        obj[key] = parseInt(params[key]);
        return obj;
      }, {});

    const prevParams = normalizeParams(this.props.params);
    const nextParams = normalizeParams(nextProps.params);

    const paramsHasChanged = !deepEqual(prevParams, nextParams);

    if (paramsHasChanged) {
      this.setState({ selectedRowKeys: [] });
    }
  }

  getData = () => {
    const { data, params } = this.props;
    // Check if the current data is set with current status filter
    // This is important to avoid showing a new row with a different status
    // when it is created by websocket
    if (Object.prototype.hasOwnProperty.call(params, 'status_id')) {
      const status = parseInt(params.status_id, 0);
      const newData = data.filter(item => item.status_id === status);
      return newData;
    }
    return data;
  };

  getColumns = () => {
    const { columns, params } = this.props;
    if (Object.keys(params).length) {
      return columns.map(column => ({
        ...column,
        sortOrder: (params.sort === column.key) && `${params.direction}end`,
      }));
    }
    return columns;
  };

  handleDeleteSelected = () => {
    const selected = this.state.selectedRowKeys;
    this.setState({ selectedRowKeys: [] }, () => {
      this.props.removeResource(this.props.resource, selected);
    });
  };

  handleClearAll = () => {
    const { resourceTypeId } = this.props;
    this.setState({ selectedRowKeys: [] }, () => {
      this.props.removeAllResources(this.props.resource, resourceTypeId);
    });
  };

  handleRowSelection = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const { resource, resourceTypeId } = this.props;
    const query = {
      page: pagination.current,
      type_id: resourceTypeId,
    };

    if (Object.keys(sorter).length) {
      const { column } = sorter;
      query.sort = column.key;
      query.direction = sorter.order === 'ascend' ? 'asc' : 'desc';
    }

    return this.props.fetchResource(resource, query);
  };

  render() {
    const {
      tableProps, isLoading, total, currentPage, resourceTypeId,
    } = this.props;

    const data = this.getData();

    return (
      <div className="data-grid">
        <Table
          columns={this.getColumns()}
          dataSource={data}
          {...tableProps}
          loading={isLoading}
          rowSelection={{
            onChange: (selectedRowKeys, row) => {
              this.handleRowSelection(selectedRowKeys, row);
            },
            selectedRowKeys: this.state.selectedRowKeys,
          }}
          onChange={this.handleTableChange}
          pagination={{
            total,
            current: currentPage,
          }}
          size="middle"
        />
        { Boolean(data.length) && (
          <div className="actions-buttons">
            <ExportCSV resourceTypeId={resourceTypeId} />
            <Popconfirm
              title="Are you sure you want to archive these tasks?"
              onConfirm={this.handleDeleteSelected}
              okText="Yes"
              okType="danger"
              cancelText="No"
            >
              <Button
                disabled={this.state.selectedRowKeys.length === 0 || isLoading}
                className="action-button"
              >
                Archive selected {Boolean(this.state.selectedRowKeys.length)
                  && <Badge count={this.state.selectedRowKeys.length} />}
              </Button>
            </Popconfirm>
            <Popconfirm
              title="Are you sure you want to archive all tasks?"
              onConfirm={this.handleClearAll}
              okText="Yes"
              okType="danger"
              cancelText="No"
            >
              <Button
                disabled={isLoading}
                className="action-button"
              >
                Archive all
              </Button>
            </Popconfirm>
            <p className="msg">*Archiving a task will not cancel any ongoing/queued activity linked to it</p>
          </div>
        )}
      </div>
    );
  }
}

DataGrid.defaultProps = {
  filters: [],
  data: [],
  isLoading: false,
};

DataGrid.propTypes = {
  params: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  data: PropTypes.array,
  tableProps: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  resource: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  // functions
  fetchResource: PropTypes.func.isRequired,
  removeAllResources: PropTypes.func.isRequired,
  removeResource: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      field: PropTypes.object.isRequired,
    })
  ),
  resourceTypeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

const mapStateToProps = ({ resources }, props) => ({
  total: resources[props.resource].total,
  currentPage: resources[props.resource].currentPage,
  data: resources[props.resource].data,
  params: resources[props.resource].params,
  isLoading: resources[props.resource].isLoading,
});

const enhanced = compose(connect(mapStateToProps, {
  fetchResource,
  saveResource,
  removeResource,
  removeAllResources,
}));
export default enhanced(DataGrid);



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGrid.js